import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getDoctorNew } from "../../../services/patient/doctor";
import Doctors from "./Doctors";

export const DoctorsTab = () => {
  const [doctorList, setDoctorList] = useState();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    getDoctorNew(2).then((res) => {
      setIsLoading(false);
      setDoctorList(res?.data?.list);
    });
  }, []);
  return (
    <>
      <Doctors
        Counselors={"No Doctor Found"}
        doctorList={doctorList}
        isLoading={isLoading}
      />
    </>
  );
};
